import { AnnouncementActionConst } from "../Constants/AnnouncementConstants";

const initialState = {
  loader: false,
  announcements: [],
  announcementsError: null,
  detail: null,
  detailError: null,
  actionSuccess: null,
  actionError: null,
};

const announcementReducer = (state = initialState, action) => {
  switch (action.type) {
    // ─── List ────────────────────────────────────────────────────────────────
    case AnnouncementActionConst.FETCH_ALL_ANNOUNCEMENTS_REQUEST:
      return { ...state, loader: true, announcementsError: null };

    case AnnouncementActionConst.FETCH_ALL_ANNOUNCEMENTS_SUCC:
      return {
        ...state,
        loader: false,
        announcements: Array.isArray(action.result.data) ? action.result.data : [],
        announcementsError: null,
      };

    case AnnouncementActionConst.FETCH_ALL_ANNOUNCEMENTS_FAIL:
      return { ...state, loader: false, announcementsError: action.result, announcements: [] };

    // ─── Detail ──────────────────────────────────────────────────────────────
    case AnnouncementActionConst.FETCH_ANNOUNCEMENT_DETAIL_REQUEST:
      return { ...state, loader: true, detail: null, detailError: null };

    case AnnouncementActionConst.FETCH_ANNOUNCEMENT_DETAIL_SUCC:
      return { ...state, loader: false, detail: action.result.data, detailError: null };

    case AnnouncementActionConst.FETCH_ANNOUNCEMENT_DETAIL_FAIL:
      return { ...state, loader: false, detailError: action.result, detail: null };

    // ─── Create ──────────────────────────────────────────────────────────────
    case AnnouncementActionConst.CREATE_ANNOUNCEMENT_REQUEST:
      return { ...state, loader: true, actionSuccess: null, actionError: null };

    case AnnouncementActionConst.CREATE_ANNOUNCEMENT_SUCC:
      return {
        ...state,
        loader: false,
        actionSuccess: action.result,
        announcements: [action.result.data, ...state.announcements],
      };

    case AnnouncementActionConst.CREATE_ANNOUNCEMENT_FAIL:
      return { ...state, loader: false, actionError: action.result, actionSuccess: null };

    // ─── Update ──────────────────────────────────────────────────────────────
    case AnnouncementActionConst.UPDATE_ANNOUNCEMENT_REQUEST:
      return { ...state, loader: true, actionSuccess: null, actionError: null };

    case AnnouncementActionConst.UPDATE_ANNOUNCEMENT_SUCC:
      return {
        ...state,
        loader: false,
        actionSuccess: action.result,
        detail: action.result.data,
        announcements: state.announcements.map((a) =>
          a.id === action.id ? action.result.data : a
        ),
      };

    case AnnouncementActionConst.UPDATE_ANNOUNCEMENT_FAIL:
      return { ...state, loader: false, actionError: action.result, actionSuccess: null };

    // ─── Remove ──────────────────────────────────────────────────────────────
    case AnnouncementActionConst.REMOVE_ANNOUNCEMENT_REQUEST:
      return { ...state, loader: true, actionSuccess: null, actionError: null };

    case AnnouncementActionConst.REMOVE_ANNOUNCEMENT_SUCC:
      return {
        ...state,
        loader: false,
        actionSuccess: action.result,
        announcements: state.announcements.filter((a) => a.id !== action.id),
      };

    case AnnouncementActionConst.REMOVE_ANNOUNCEMENT_FAIL:
      return { ...state, loader: false, actionError: action.result, actionSuccess: null };

    // ─── Clear ───────────────────────────────────────────────────────────────
    case AnnouncementActionConst.CLEAR_ANNOUNCEMENT_ACTION_STATE:
      return { ...state, actionSuccess: null, actionError: null };

    default:
      return state;
  }
};

export default announcementReducer;
